/** 附件API */
import type { FlatResponseData } from '@sa/axios';
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/base/attachment';
/**
 * 分页查询附件
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Base.Attachment> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询附件列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Base.Attachment> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个附件
 *
 * @param id 附件ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Base.Attachment> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存附件
 *
 * @param params 附件信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新附件信息
 *
 * @param params 附件信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除附件
 *
 * @param id 附件ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除附件
 *
 * @param ids 附件ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/** 通过项目id查询 */
export const findByProjectId: (
  params: Record<string, any> | undefined
) => Promise<FlatResponseData<Api.Common.CommonQueryResult<Api.Base.Attachment>>> = params => {
  return post(`${prefix}/getAttachmentList`, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  findByProjectId
};
